import React, { Component } from 'react';
import PropTypes from "prop-types";

import catchLifeCycleErrors from 'utils/catchLifeCycleErrors';
import {StandardPage} from "../../Common/pages/StandardPage";
import {RightColumn} from "../../Common/pages/RightColumn";

@catchLifeCycleErrors
export default class HorseRacingMeetingLandingPage extends Component {
  static propTypes = {
    HorseRacingMeetingLandingContainer: PropTypes.element.isRequired,
    location: PropTypes.object.isRequired,
  };

  render() {
    const {
      location,
      HorseRacingMeetingLandingContainer,
    } = this.props;

    return (
      <div className="meeting-landing-page">
        <StandardPage sport="racing" title="Meeting Page">
          <div className="main-layout-left-column">
            {HorseRacingMeetingLandingContainer}
          </div>

          <RightColumn location={location}
                       sport="racing"
                       content={
                         ["topMpu", "horseRacingNextRaceOffAll", "racingTips", "bottomMpu",  "ocWidget"]} />
        </StandardPage>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/HorseRacing/containers/HorseRacingMeetingLandingPage.js